import React, { Component } from 'react'
import { connect } from 'react-redux';
import withAppShell from '../../hoc/withAppShell/WithAppShell';
import spinner from "../../ui/icons/spinner.gif";
import OrderComponent from './OrderComponent'
import { OrderActions } from '../../../store'
import { MuiGrid } from '../../ui/MaterialUIComponents'
import lodashUtil from 'lodash'
import { getKeyFromLS } from '../../../utils/LocalStorageUtil'
import theme from "../../../assests/theme"
class OrderHistoryContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }
    componentWillMount() {
        let schoolName;
        if (this.props.location !== undefined && this.props.location.state !== undefined && this.props.location.state.schoolId) {
            this.props.getOrderHistoryBySchoolId(this.props.location.state.schoolId)
            schoolName = this.props.location.state.schoolName;
        }
        let i18n;
        if (this.props.i18n === undefined || lodashUtil.isEmpty(this.props.i18n)) {
            i18n = getKeyFromLS("i18n");
        } else {
            i18n = this.props.i18n
        }
        this.setState({
            i18n: i18n,
            schoolName:schoolName
        })
    }

    render() {
        return <MuiGrid style={{ width: '100%' }}>
            {!this.props.fetchOrderHistoryInProgress ?

                <OrderComponent {...this.props} {...this.state} /> :
                <MuiGrid>
                    <img src={spinner} alt="none" style={theme.spinnerImgStyle} />
                </MuiGrid>
            }
        </MuiGrid>
    }
}

const mapDispatchToProps = (dispatch) => ({
    getOrderHistoryBySchoolId: (schoolId) => dispatch(OrderActions.getOrderHistoryBySchoolId(schoolId))
})
const mapStateToProps = (state, ownProps) => {
    return {
        orderHistory: state.order.orderHistory,
        fetchOrderHistoryInProgress: state.order.fetchOrderHistoryInProgress,
        fetchOrderHistoryInFailed: state.order.fetchOrderHistoryInFailed,
        activeSchool: state.schoolInformation.activeSchool,
        i18n: state.i18nMessages.i18n,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withAppShell(OrderHistoryContainer))